 window.customCodeForHulkReviewBadge = ()=>{
    let showingReviewsTotal = document.querySelectorAll('[data-hulkapps-reviews]')[0];
if(showingReviewsTotal){
    try {
        let reviewBadgeLoaded = setInterval((event) =>{
        let e=document.querySelectorAll('[data-hulkapps-reviews] .hulk-review-total');
        if(e.length) {
        clearInterval(reviewBadgeLoaded);
        e.forEach ( f =>{
            if(f.innerText.toLowerCase().includes('reviews')){
                let inText = f.innerText.toLowerCase().replace(' reviews','');
                f.innerText = '('+inText+')';
            }
        })
        }
        }, 500);
        setTimeout ( ()=>{ clearInterval( reviewBadgeLoaded);},30000);
        }
        catch(err){
        console.log('error in making changes into reviews badge');
        }
    }
}
window.addEventListener('load', function () {
    window.customCodeForHulkReviewBadge();
});

